import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const defaultRole = searchParams.get('role') === 'owner' ? 'owner' : 'buyer';

  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', password: '', role: defaultRole });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function set(key) { return e => setForm(f => ({ ...f, [key]: e.target.value })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await register(form);
      navigate(user.role === 'owner' ? '/dashboard/owner' : '/dashboard/buyer', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || (err.response?.data?.errors?.[0]?.msg) || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Create your account</h1>
        <p className="subtitle">Join ShareTime — it only takes a minute</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          {/* Role selector */}
          <div className="form-group">
            <label>I want to…</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
              {['owner', 'buyer'].map(r => (
                <label key={r} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.65rem', border: `2px solid ${form.role === r ? 'var(--brand)' : 'var(--border)'}`, borderRadius: 'var(--radius-sm)', cursor: 'pointer', background: form.role === r ? 'var(--brand-light)' : 'var(--surface)', transition: 'all 0.15s' }}>
                  <input type="radio" name="role" value={r} checked={form.role === r} onChange={set('role')} style={{ width: 'auto' }} />
                  {r === 'owner' ? 'List my property' : 'Book a stay'}
                </label>
              ))}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <div className="form-group">
              <label htmlFor="firstName">First name</label>
              <input id="firstName" type="text" required value={form.firstName} onChange={set('firstName')} />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last name</label>
              <input id="lastName" type="text" required value={form.lastName} onChange={set('lastName')} />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" required autoComplete="email" value={form.email} onChange={set('email')} />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input id="password" type="password" required minLength={8} autoComplete="new-password" value={form.password} onChange={set('password')} />
            <span className="field-hint">At least 8 characters</span>
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Creating account…' : 'Create account'}
          </button>
        </form>

        <p className="auth-switch">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
}
